import { useAuth0 } from '@auth0/auth0-react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
    Box,
    Button,
    Grid,
    LinearProgress,
    Skeleton,
    Stack,
    styled,
    Typography,
    Paper,
} from '@mui/material';
import axios from 'axios';
import { compareDesc, format, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import approvalImage from '../../assets/approvalImage.png';
import ratingImage from '../../assets/rating.png';
import shiftImage from '../../assets/shiftImage.png';
import {
    addAvailability,
    fetchMyAvailability,
    updateStatus as updateAvailStatus,
} from '../../redux/AvailabilitySlice';
import {
    quickBookingConfirmed,
    updateStatus as updateBookingStatus,
} from '../../redux/BookingSlice';
import StatusIndicator from '../BasicComponents/StatusIndicator';
import TitleCase from '../BasicComponents/TitleCase';
import SimpleSnackBar from '../SnackBar/SimpleSnackbar';
import sendNotification from '../../utils/sendNotification';
import SignSchoolDocs from '../BasicComponents/SignSchoolDocs';

const IconImage = styled('img')(({ theme }) => ({
    height: '40px',
    borderRadius: '5%',
}));

const GridCenter = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

const Image = styled('img')(({ theme }) => ({
    width: '100%',
    borderRadius: '5%',
    height: 'auto',
}));

const PaperBox = styled(Paper)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    minWidth: 330,
    [theme.breakpoints.down('sm')]: {
        minWidth: '242px',
    },
    margin: '5px 0px',
    padding: '15px 0px',
    borderRadius: 15,
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
    fontSize: '1rem',
    [theme.breakpoints.down('md')]: {
        fontSize: '.8rem',
    },
}));
export const BookingSummary = props => {
    let history = useHistory();
    const dispatch = useDispatch();

    const [filteredBookings, setFilteredBookings] = useState([]);
    const [snack, setSnack] = useState({
        loading: false,
        snackBarMessage: '',
        openSnack: false,
        snackSeverity: 'success',
    });

    // For Signing school docs
    const [signDocsOpen, setSignDocsOpen] = useState(false);
    const [schoolDocsInfo, setSchoolDocsInfo] = useState();
    const [cached, setCached] = useState({});

    const { profile } = useSelector(state => state.profile);
    const { availability } = useSelector(state => state.availability);
    const availabilityStatus = useSelector(state => state.availability.status);

    useEffect(() => {
        if (!props.loading) {
            if (typeof props.booking === 'object') {
                const tempFilteredArray = props.booking.filter(booking => {
                    if (
                        (booking.status === props.status ||
                            booking.status === props.status2) &&
                        compareDesc(parseISO(booking.endDate), Date.now()) ===
                            -1 &&
                        props.profileType === 'Teacher'
                    ) {
                        return true;
                    } else if (
                        ((booking.status === 'Approved' &&
                            booking.status === props.status &&
                            compareDesc(
                                parseISO(booking.endDate),
                                Date.now()
                            ) === -1) ||
                            (booking.status === 'Completed' &&
                                booking.status === props.status &&
                                compareDesc(
                                    parseISO(booking.endDate),
                                    Date.now()
                                ) === 1) ||
                            (booking.status === 'Pending Rating' &&
                                booking.status === props.status3 &&
                                compareDesc(
                                    parseISO(booking.endDate),
                                    Date.now()
                                ) === 1)) &&
                        props.profileType === 'School'
                    ) {
                        return true;
                    }
                    return false;
                });
                setFilteredBookings(tempFilteredArray);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loading, props.booking]);

    const { getAccessTokenSilently } = useAuth0();

    const navigateToDetails = uniqueId => {
        if (props.profileType === 'Teacher') {
            history.push('/history/teacher-booking/' + uniqueId);
        } else if (props.profileType === 'School') {
            history.push('/history/school-booking/' + uniqueId);
        }
    };

    const getAvailability = (avail, token, row) => {
        return new Promise(async (resolve, reject) => {
            if (avail.length > 0) {
                console.log('availExists - Setting availLocal', avail);
                resolve({
                    'pk1': avail[0].pk1,
                    'sk1': avail[0].sk1,
                });
            } else {
                //create availability
                console.log('profile', profile);
                let dynamoData = {
                    token: token,
                    request: {
                        grade: profile.Data.Items[0].grades,
                        address: profile.Data.Items[0].address,
                        addDates: [
                            {
                                startDate: row.startDate,
                                endDate: row.endDate,
                            },
                        ],
                        lat: profile.Data.Items[0].lat,
                        long: profile.Data.Items[0].long,
                        type: profile.Data.Items[0].type,
                        teacherName: profile.Data.Items[0].sk1,
                        teacherProfile: profile.Data.Items[0].profileImage,
                        skills: profile.Data.Items[0].skills,
                        otherSkills: profile.Data.Items[0].otherSkills,
                        bio: profile.Data.Items[0].bio,
                        repeat: 0,
                        status: 'Available',
                    },
                };
                console.log(
                    'Data to Send ' + JSON.stringify(dynamoData.request)
                );
                const outcome = await dispatch(addAvailability(dynamoData));
                console.log('outcome', outcome);
                resolve({
                    'pk1': outcome.payload.data.availability[0].Message.Data
                        .pk1,
                    'sk1': outcome.payload.data.availability[0].Message.Data
                        .sk1,
                });
            }
        });
    };

    const addQuickBookAndAvail = async (
        bookingItem,
        avail,
        changeStatus,
        token,
        date,
        approve,
        originalStatus
    ) => {
        //data.pk1 = 'r1r34-20210824' // state.booking.startDate = '2022-10-29T08:00:00'

        const availExists = avail.filter(
            data =>
                data.pk1.substring(6) ===
                `${bookingItem.startDate.substr(
                    0,
                    4
                )}${bookingItem.startDate.substr(
                    5,
                    2
                )}${bookingItem.startDate.substr(8, 2)}`
        );
        const availabilityLocal = await getAvailability(availExists, token);
        const data = {
            'request': {
                'approve': approve.toString(),
                'date': date,
                'availPk1': availabilityLocal.pk1,
                'availSk1': availabilityLocal.sk1,
                'bookPk1': bookingItem.pk1,
                'bookSk1': bookingItem.sk1,
            },
        };
        console.log('Call 1');
        const route = '/confirmQuickBooking';
        const response = await axios
            .put(route, data.request, {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: route,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(response => {
                console.log('response', response);

                try {
                    const availStatus = {
                        status: response.data.Message.Data.availStatus,
                        id: response.data.Message.Data.availUniqueId,
                    };
                    dispatch(updateAvailStatus(availStatus));
                } catch {
                    console.log('Availability not in memory');
                }

                if (response.data.Message.Code === 'Awaiting Sign') {
                    setSchoolDocsInfo({
                        docs: response.data.Message.Data.results,
                        logo: bookingItem.schoolLogo,
                        name: bookingItem.schoolName,
                    });
                    setSignDocsOpen(true);
                    let changeStatus = {
                        status: 'Pending',
                        id: bookingItem.uniqueId,
                    };
                    dispatch(updateBookingStatus(changeStatus));
                    return;
                }

                dispatch(quickBookingConfirmed(response.data));
                // setSnack({
                //     snackBarMessage: 'Booking Updated',
                //     openSnack: true,
                //     snackSeverity: 'success',
                // });
                sendNotification('success', 6000, 'Booking Updated');
            })
            .catch(err => {
                changeStatus.status = originalStatus;
                dispatch(updateBookingStatus(changeStatus));
                console.log('Alert Customer of Failure');
                // setSnack({
                //     snackBarMessage: 'Booking Failed to Update',
                //     openSnack: true,
                //     snackSeverity: 'error',
                // });
                sendNotification('error', 0, 'Booking Failed to Update');
            });
        console.log('Response from API ' + JSON.stringify(response));
    };

    const confirmBooking = async (event, approve, row) => {
        if (event === undefined) {
            event = cached.event;
            approve = cached.approve;
            row = cached.row;
        } else {
            setCached({
                event: event,
                approve: approve,
                row: row,
            });
        }
        event.stopPropagation();
        console.log('index item ' + JSON.stringify(row));
        // Trying to use same outcome

        try {
            const originalStatus = row.status;

            let changeStatus = {
                status: 'Processing',
                id: row.uniqueId,
            };
            dispatch(updateBookingStatus(changeStatus));
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });

            if (row.type === 'quickBook') {
                if (availabilityStatus === 'idle') {
                    const availStatus = await dispatch(
                        fetchMyAvailability(token)
                    );
                    console.log('availStatus', availStatus);
                    if (
                        availStatus.payload.availability.Message.Success ===
                        true
                    ) {
                        //data.pk1 = 'r1r34-20210824' // state.booking.startDate = '2022-10-29T08:00:00'

                        await addQuickBookAndAvail(
                            row,
                            availStatus.payload.availability.Message.Data,
                            changeStatus,
                            token,
                            row.sk1,
                            approve,
                            originalStatus
                        );
                    }
                } else {
                    //find the availability that matches the day then add to the availability

                    await addQuickBookAndAvail(
                        row,
                        availability.Data,
                        changeStatus,
                        token,
                        row.sk1,
                        approve,
                        originalStatus
                    );
                }
            } else {
                const data = {
                    'request': {
                        'approve': approve.toString(),
                        'date': row.sk1,
                    },
                };
                const route = '/confirmBooking';

                const response = await axios
                    .put(route, data.request, {
                        baseURL: process.env.REACT_APP_API_GATEWAY,
                        url: route,
                        timeout: 30000,
                        headers: {
                            authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    })
                    .then(response => {
                        try {
                            let availStatus = {
                                status: response.data.Message.Data.availStatus,
                                id: response.data.Message.Data.availUniqueId,
                            };
                            dispatch(updateAvailStatus(availStatus));
                        } catch {
                            console.log('Availability not in memory');
                        }

                        if (response.data.Message.Code === 'Awaiting Sign') {
                            setSchoolDocsInfo({
                                docs: response.data.Message.Data.results,
                                logo: row.schoolLogo,
                                name: row.schoolName,
                            });
                            setSignDocsOpen(true);
                            let changeStatus = {
                                status: 'Pending',
                                id: row.uniqueId,
                            };
                            dispatch(updateBookingStatus(changeStatus));
                            return;
                        }

                        changeStatus.status =
                            response.data.Message.Data.bookingStatus;
                        dispatch(updateBookingStatus(changeStatus));
                        // setSnack({
                        //     loading: false,
                        //     snackBarMessage: 'Booking Updated',
                        //     openSnack: true,
                        //     snackSeverity: 'success',
                        // });
                        sendNotification('success', 6000, 'Booking Updated');
                    })
                    .catch(err => {
                        changeStatus.status = originalStatus;
                        dispatch(updateBookingStatus(changeStatus));
                        console.log('Alert Customer of Failure');
                        // setSnack({
                        //     loading: false,
                        //     snackBarMessage: 'Booking Failed to Update',
                        //     openSnack: true,
                        //     snackSeverity: 'error',
                        // });
                        sendNotification(
                            'error',
                            0,
                            'Booking Failed to Update'
                        );
                    });
                console.log('Response from API ' + JSON.stringify(response));
            }
        } catch (err) {
            console.log('error', err);
        }
    };

    return (
        <Box
            sx={{
                backgroundColor: '#FFF',
                borderRadius: '5px',
                boxShadow: '1px 1px 9px -2px rgb(0 0 0 / 20%)',
                width: '100%',
            }}
        >
            {/* <Typography variant="h6" sx={{ m: 1 }} color="primary">
                You have a total of {filteredBookings.length} {props.type}
            </Typography> */}

            <Stack
                sx={{
                    boxShadow: '0px 3px 9px -2px rgb(0 0 0 / 20%)',
                    display: 'flex',
                    alignItems: 'flex-start',
                    width: '100%',
                }}
                direction="column"
            >
                <Typography
                    variant="h5"
                    sx={{ padding: '8px', textAlign: 'left', width: '100%' }}
                >
                    {props.title}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        margin: '8px',
                        textAlign: 'center',
                        display: 'none',
                    }}
                >
                    {props.subtitle}
                </Typography>
            </Stack>
            {props.loading === true ? (
                <Box sx={{ margin: '8px 0px' }}>
                    <Grid container>
                        <Grid item xs={2} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                        <Grid item xs={2} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                        <Grid item xs={6} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                        <Grid item xs={1} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={2} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                        <Grid item xs={2} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                        <Grid item xs={6} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                        <Grid item xs={1} sx={{ padding: '8px' }}>
                            <Skeleton height={60}></Skeleton>
                        </Grid>
                    </Grid>
                </Box>
            ) : (
                <>
                    {filteredBookings.length > 0 ? (
                        <div
                            style={{
                                padding: '10px',
                                display:
                                    props.profileType === 'Teacher' &&
                                    props.title === 'Available Local Bookings'
                                        ? 'flex'
                                        : 'block',
                                gap:
                                    props.profileType === 'Teacher' &&
                                    props.title === 'Available Local Bookings'
                                        ? 50
                                        : 0,

                                overflowX:
                                    props.profileType === 'Teacher' &&
                                    props.title === 'Available Local Bookings'
                                        ? 'scroll'
                                        : '',
                            }}
                        >
                            {filteredBookings.map((row, index) => (
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                    }}
                                    key={row.uniqueId}
                                    onClick={event => {
                                        event.preventDefault();
                                        navigateToDetails(row.uniqueId);
                                    }}
                                >
                                    {/* {row.status === props.status &&
                        compareDesc(parseISO(row.endDate), Date.now()) ===
                            -1 && ( */}
                                    {props.profileType === 'Teacher' &&
                                        props.title ===
                                            'Available Local Bookings' && (
                                            <PaperBox elevation={4}>
                                                <Box
                                                    sx={{ margin: 'auto 10px' }}
                                                >
                                                    <Image
                                                        src={row.schoolLogo}
                                                    />
                                                </Box>
                                                <Box
                                                    sx={{
                                                        textAlign: 'left',
                                                        padding: '0px 5px',
                                                    }}
                                                >
                                                    <StyledTypography>
                                                        {row.schoolName}
                                                    </StyledTypography>
                                                    <Typography
                                                        variant="h5"
                                                        sx={{
                                                            margin: '8px 0px 0px 0px',
                                                            fontSize: [
                                                                '1rem',
                                                                '1.5rem',
                                                                '1.5rem',
                                                            ],
                                                        }}
                                                    >
                                                        {format(
                                                            parseISO(
                                                                row.startDate
                                                            ),
                                                            'dd'
                                                        )}{' '}
                                                        {format(
                                                            parseISO(
                                                                row.startDate
                                                            ),
                                                            'MMM'
                                                        )}
                                                    </Typography>
                                                    <StyledTypography>
                                                        {format(
                                                            parseISO(
                                                                row.startDate
                                                            ),
                                                            'h:mma'
                                                        )}
                                                        {'-'}
                                                        {format(
                                                            parseISO(
                                                                row.endDate
                                                            ),
                                                            'h:mma'
                                                        )}
                                                    </StyledTypography>
                                                </Box>
                                            </PaperBox>
                                        )}
                                    <Grid
                                        container
                                        sx={{
                                            display:
                                                props.profileType ===
                                                    'Teacher' &&
                                                props.title ===
                                                    'Available Local Bookings'
                                                    ? 'none'
                                                    : '',
                                        }}
                                    >
                                        <GridCenter
                                            item
                                            xs={2}
                                            sx={{ padding: '8px 0px' }}
                                        >
                                            {props.profileType === 'School' ? (
                                                <Image
                                                    src={row.teacherProfile}
                                                />
                                            ) : (
                                                <Image src={row.schoolLogo} />
                                            )}
                                        </GridCenter>

                                        <GridCenter item xs={7}>
                                            {props.profileType === 'School' ? (
                                                <Box>
                                                    <TitleCase
                                                        variant="h6"
                                                        string={`${row.teacherFirstName} ${row.teacherLastName}`}
                                                    />
                                                    {props.showTime && (
                                                        <Stack direction="row">
                                                            <AccessTimeIcon />
                                                            <Typography variant="body1">
                                                                {format(
                                                                    parseISO(
                                                                        row.startDate
                                                                    ),
                                                                    'h:mma'
                                                                )}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                    {props.showStatus && (
                                                        <StatusIndicator
                                                            status={row.status}
                                                        ></StatusIndicator>
                                                    )}
                                                </Box>
                                            ) : (
                                                <TitleCase
                                                    sx={{
                                                        fontSize: [
                                                            '1rem',
                                                            '1.5rem',
                                                            '1.5rem',
                                                        ],
                                                    }}
                                                    string={row.schoolName}
                                                />
                                            )}
                                        </GridCenter>
                                        <GridCenter item xs={3}>
                                            <Box>
                                                <Typography
                                                    variant="h3"
                                                    sx={{
                                                        margin: '8px 0px',
                                                        fontSize: [
                                                            '1.2rem',
                                                            '1.5rem',
                                                            '1.5rem',
                                                        ],
                                                    }}
                                                >
                                                    {format(
                                                        parseISO(row.startDate),
                                                        'dd'
                                                    ) +
                                                        ' ' +
                                                        format(
                                                            parseISO(
                                                                row.startDate
                                                            ),
                                                            'MMM'
                                                        )}
                                                </Typography>
                                                <StyledTypography
                                                    sx={{
                                                        fontSize: [
                                                            '.7rem',
                                                            '1rem',
                                                            '1rem',
                                                        ],
                                                    }}
                                                >
                                                    {format(
                                                        parseISO(row.startDate),
                                                        'h:mma'
                                                    )}
                                                    {'-'}
                                                    {format(
                                                        parseISO(row.endDate),
                                                        'h:mma'
                                                    )}
                                                </StyledTypography>
                                            </Box>
                                        </GridCenter>
                                        {/*  <GridCenter item xs={1}>
                                            <KeyboardArrowRightIcon></KeyboardArrowRightIcon>
                                        </GridCenter>*/}
                                    </Grid>
                                    <Grid container>
                                        <GridCenter item xs={12}>
                                            {row.status === 'Pending' &&
                                                props.title !==
                                                    'Available Local Bookings' &&
                                                props.profileType ===
                                                    'Teacher' && (
                                                    <Button
                                                        variant="outlined"
                                                        color="secondary"
                                                        size="small"
                                                        sx={{
                                                            margin: '8px',
                                                            height: '40px',
                                                            width: '100px',
                                                        }}
                                                        onClick={e => {
                                                            confirmBooking(
                                                                e,
                                                                true,
                                                                row
                                                            );
                                                        }}
                                                        startIcon={
                                                            <CheckCircleOutlineIcon color="sexysuccess" />
                                                        }
                                                    >
                                                        Accept
                                                    </Button>
                                                )}
                                            {row.status === 'Pending' &&
                                                props.title !==
                                                    'Available Local Bookings' &&
                                                props.profileType ===
                                                    'Teacher' && (
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        size="small"
                                                        sx={{
                                                            margin: '8px',
                                                            height: '40px',
                                                            width: '100px',
                                                        }}
                                                        onClick={e => {
                                                            confirmBooking(
                                                                e,
                                                                false,
                                                                row
                                                            );
                                                        }}
                                                        startIcon={
                                                            <RemoveCircleOutlineIcon color="sexyerror" />
                                                        }
                                                    >
                                                        Decline
                                                    </Button>
                                                )}
                                        </GridCenter>

                                        {row.status === 'Processing' && (
                                            <Grid item sx={{ width: '100%' }}>
                                                <LinearProgress />
                                            </Grid>
                                        )}
                                    </Grid>
                                    {/* )} */}
                                </Box>
                            ))}
                        </div>
                    ) : (
                        <Box>
                            {props.title === 'Upcoming Shifts' && (
                                <Box>
                                    <Typography
                                        variant="h6"
                                        sx={{ padding: '20px' }}
                                    >{`Sorry, There are no upcoming shifts`}</Typography>
                                    <IconImage
                                        src={shiftImage}
                                        sx={{ marginBottom: '20px' }}
                                    />
                                </Box>
                            )}
                            {props.title === 'Ratings Required' && (
                                <Box>
                                    <Typography
                                        variant="h6"
                                        sx={{ padding: '20px' }}
                                    >{`Well Done, All reviews are complete`}</Typography>
                                    <IconImage
                                        src={ratingImage}
                                        sx={{ marginBottom: '20px' }}
                                    />
                                </Box>
                            )}
                            {props.title === 'Bookings to Approve' && (
                                <Box>
                                    <Typography
                                        variant="h6"
                                        sx={{ padding: '20px' }}
                                    >{`Well Done, No bookings to approve`}</Typography>
                                    <IconImage
                                        src={approvalImage}
                                        sx={{ marginBottom: '20px' }}
                                    />
                                </Box>
                            )}
                        </Box>
                    )}
                </>
            )}
            {signDocsOpen && (
                <SignSchoolDocs
                    setOpen={setSignDocsOpen}
                    schoolDocsInfo={schoolDocsInfo}
                    setSnack={setSnack}
                    confirmBooking={confirmBooking}
                />
            )}
            <SimpleSnackBar
                open={snack.openSnack}
                severity={snack.snackSeverity}
                Message={snack.snackBarMessage}
            />
        </Box>
    );
};

export default BookingSummary;
